export default __webpack_public_path__ + "static/media/MaceoThompson.43e47ea5.jpg";